import React, { useEffect, useState } from 'react'
import { BackArrowButton, Button, Dropdown, IDropdownItem } from '@doseme/cohesive-ui'
import saveAs from 'file-saver'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { REPORTS_URL } from '../../../../constants/urls/frontend'
import { TProps } from './types'
import { REPORTS_DMA_CSV_URL } from '../../../../constants/urls/backend'
import { apiRoute } from '../../../../utils/routeUtils'
import { axiosWithAdal } from '../../../../utils/http'

import './index.scss'

const DrugModelAccess: React.FC<TProps> = ({ drugs, fetchDrugs, history }): JSX.Element => {
  const [drugModelSelectedValue, setDrugModelSelectedValue] = useState<IDropdownItem | null>(null)
  const [downloading, setDownloading] = useState(false)
  const handleBackArrowButton = () => {
    history.push(REPORTS_URL)
  }

  useEffect(() => {
    if (!drugs.touched) {
      fetchDrugs()
    }
  }, [drugs.touched, fetchDrugs])

  const submitRequest = async () => {
    if (drugModelSelectedValue) {
      setDownloading(true)

      const config: AxiosRequestConfig = {
        headers: {
          Accept: 'text/csv'
        }
      }

      await axiosWithAdal
        .get(apiRoute(REPORTS_DMA_CSV_URL(drugModelSelectedValue.value)), config)
        .then((response: AxiosResponse) => {
          const reportFileResponse = response.data as string
          const reportFileBlob = new Blob([reportFileResponse], { type: 'application/csv' })
          saveAs(
            reportFileBlob,
            response.headers['content-disposition']?.match(/"([^"]+)"/)?.[1] ||
              `subscriptions_for_drug_model_${drugModelSelectedValue.value}.csv`
          )
        })
        .catch((error) => {
          alert('unable to retrieve requested data: ' + JSON.stringify(error))
        })
      setDownloading(false)
    }
  }

  const formatDropdownData = (): IDropdownItem[] => {
    const dropdownItems: IDropdownItem[] = []
    for (const x of Object.keys(drugs.all)) {
      dropdownItems.push({ value: drugs.all[x].id.toString(), label: drugs.all[x].name })
    }

    return dropdownItems
  }

  return (
    <div className='dma-wrapper'>
      <div className='dma-back-button'>
        <BackArrowButton onClick={handleBackArrowButton} />
      </div>
      <div>
        <div className='dma-title'>Create report: drug model access</div>
        <div className='create-report-container'>
          <div className='dma-subtitle'>Generate a list of hospitals with access to the selected drug model</div>
          <div>
            <Dropdown
              data={drugs.ids.length > 0 ? formatDropdownData() : []}
              onSelect={(item) => setDrugModelSelectedValue(item)}
              value={drugModelSelectedValue?.value}
              label='Select drug model:'
              placeholder='Drug model...'
              fieldState='valid'
            />
          </div>
          <div className='dma-seperater-line'></div>
          <div className='dma-download-btn'>
            <Button onClick={submitRequest} loading={downloading} variant='primary'>
              Download
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export { DrugModelAccess }
